import { MicrodistrictType, CreateMicrodistrictType } from "@app/api/microdistrict.api"
import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '@app/api';
import { RootState } from 'src/store';

export const createMicrodistrictThunk = createAsyncThunk<MicrodistrictType, CreateMicrodistrictType>("@@microdistricts/create", async (dto) => {
	return await api.microdistrict.create(dto)
})

export function createMicrodistrictThunkPending(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.createMicrodistrictIsLoading = true
}

export function createMicrodistrictThunkRejected(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.createMicrodistrictIsLoading = false
}

export function createMicrodistrictThunkFullfilled(state: RootState["geoGuidMicrodistrictsSlice"], { payload }: PayloadAction<MicrodistrictType>) {
	state.createMicrodistrictIsLoading = false
	state.microdistricts.push(payload)
	state.showAddMicrodistrictModal = false
}
